var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemActionCardPrimary',{attrs:{"action":_vm.createTenantTeam,"header":"Create new team"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._v(" Create your own team for resource planning & skills analysis. ")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }